const state = {
  sidebarVisible: true,
  dashboardConfig: null,
  menuUserNavBarVisible: false,
};

export default state;
